import {
    AppBar,
    Box,
    Card,
    CardContent,
    CardHeader,
    Container,
    Divider,
    Grid,
    IconButton,
    makeStyles,
    NoSsr,
    Tab,
    Tabs,
    Theme,
    Toolbar,
    Typography,
} from "@material-ui/core";
import { ArrowBack, Close } from "@material-ui/icons";
import React from "react";
import { RouteChildrenProps, useHistory } from "react-router-dom";
import CommunitySection from "./CommunitySection/CommunitySection";
import CriticSection from "./CriticSection/CriticSection";
import StorySection from "./StorySection/StorySection";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        height: "100vh",
        paddingTop: theme.spacing(12),
    },
    appBar: {
        paddingInline: theme.spacing(3),
        backgroundColor: theme.palette.background.paper,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    header: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));

const WriterFeedback: React.FC<RouteChildrenProps> = ({ history, match }) => {
    const classes = useStyles();
    const { id } = match?.params as { id: string };
    const [value, setValue] = React.useState(0);

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue);
    };

    return (
        <NoSsr>
            <AppBar className={classes.appBar} color="default" position="fixed">
                <Toolbar>
                    <IconButton
                        edge="start"
                        className={classes.menuButton}
                        color="inherit"
                        aria-label="menu"
                        onClick={() => history.goBack()}
                    >
                        <ArrowBack />
                    </IconButton>
                    <Typography variant="h6" className={classes.title}>
                        Go back
                    </Typography>
                </Toolbar>
            </AppBar>

            <Container className={classes.root} maxWidth="md">
                <Grid container spacing={3}>
                    <Grid item xs={12} lg={8}>
                        <Card>
                            <div className={classes.header}>
                                <Typography variant="h5">
                                    All Feedback
                                </Typography>
                            </div>
                            <Box>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="basic tabs example"
                                >
                                    <Tab label="Critics" />
                                    <Tab label="Community" />
                                </Tabs>
                            </Box>
                            <Divider />
                            {value === 0 && <CriticSection id={id} />}
                            {value === 1 && <CommunitySection id={id} />}
                        </Card>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                        <StorySection id={id} />
                    </Grid>
                </Grid>
            </Container>
        </NoSsr>
    );
};

export default WriterFeedback;
